module.exports = __webpack_public_path__ + "img/base_rate.6cf59eff.svg";